{
  "w": 8,
  "h": 12,
  "rows": [
    "..GG....",
    ".GGWWGG.",
    ".GWWGG..",
    ".WWGGWW.",
    "GGGGGGG.",
    "G.GGGGGG",
    ".GGGGGG.",
    "...RR...",
    "...RR...",
    "...RR...",
    "...RR...",
    "...WWW.."
  ],
  "legend": {
    "G": "C.B_GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
